import React, {Component} from 'react';
import {observable, action} from 'mobx';
import service from '../service';
import axios from 'axios';
import config from "../config";
class EventStore {

    @observable event;
    @observable error = false;
    @observable result;
    @observable stateFlow;
    @observable member;
    requestType = 'member';
    @observable memberOption = [];

    constructor(serviceGroup, collection) {
        this.service = serviceGroup;
        this.eventId = null;
        this.stateFlow = 0;
        this.httpClient = axios.create({
            baseURL: `http://${config.services.v2.uri}:${config.services.v2.port}`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
    }

    @action
    reInit() {
        this.stateFlow = 0;
    }

    @action
    async load(id) {
        this.eventId = id;
        let eventResponse;
        try {
            const url = `api/events/event/${id}`;
            eventResponse = await this.httpClient.get(url);
            this.event = eventResponse.data;
            this.stateFlow = 0;
            console.log(this.event)
        }
        catch (err) {

        }
    }

    @action
    async searchMember(dataInput) {
        let eventResponse;
        try {
            const url = `api/events/event/search_member`;
            eventResponse = await this.httpClient.get(url, {
                params: { code: dataInput }});
            this.memberOption = [];
            const response = eventResponse.data;
            const data = [];
            Object.keys(response).map(x => {
                this.memberOption.push({value: x, label: `${x} : ${response[x]}`});
                data.push({value: x, label: `${x} : ${response[x]}`});
            });
            return data.map(x => x);
        }
        catch (err) {

        }
        return [{value: '', label: ''}];
    }

    @action
    async checkPreAttendee(id, dataInput) {
        let eventResponse;
        try {
            const url = `api/events/event/${id}/check_pre_attendee`;
            eventResponse = await this.httpClient.get(url, {
                params: { code: dataInput }});
            this.memberOption = [];
            // this.stateFlow = 1;
            return eventResponse.data;
        }
        catch (err) {
            console.log(err.response.data);
            this.member = err.response.data.member;
            this.result = err.response.data;
            return err.response
        }
    }

    @action
    async preRegister(id, dataInput, group) {
        let eventResponse;
        try {
            const url = `api/events/event/${id}/pre_register`;
            eventResponse = await this.httpClient.post(url, {
                 code: dataInput, group: group });
            this.memberOption = [];
            // this.stateFlow = 1;
            return eventResponse.data;
        }
        catch (err) {
            console.log(err.response.data);
            this.member = err.response.data.member;
            this.result = err.response.data;
            return err.response
        }
    }


    @action
    async register(body) {
        let eventResponse;
        try {
            const url = `api/events/event/${this.eventId}/register`;
            eventResponse = await this.httpClient.post(url, body);
            this.result = eventResponse.data;
            this.member = eventResponse.data;
            this.stateFlow = 2;
        }
        catch (err) {
            this.stateFlow = 255;
            this.result = err.response;
            console.log(err.response);
        }
    }

    setRoute(next) {
        this.stateFlow = next;
    }
}


export default new EventStore(service.event);



// WEBPACK FOOTER //
// ./src/store/EventStore.js